export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9749.2d8f75ed.jpg";